/* afzuigkapSpecialist.nl: megamenu desktop (11 okt 2026, WERK 20).
   Eén paneel per hoofditem: sfeerbeeld links, modellen rechts, USP-balk onder.
   Bron = het Shopify-menu (links/volgorde) + window.WAVE_MEGA (beelden, teksten) uit snippets/wave-menu-art.
   Mobiel (< 900px) blijft het bestaande menu (wave-menu.js). */
(function () {
  'use strict';
  var nav = document.querySelector('.main-nav');
  var M = window.WAVE_MEGA;
  if (!nav || !M || nav.getAttribute('data-wmx')) return;
  nav.setAttribute('data-wmx', '1');
  var ART = window.WAVE_MENU_ART || {}, INFO = window.WAVE_MENU_INFO || {};
  var mq = window.matchMedia('(min-width: 900px)');
  var tops = Array.prototype.slice.call(nav.querySelectorAll(':scope > li'));
  var openLi = null, tOpen = 0, tClose = 0, built = false;

  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function key(href) {
    try { var p = new URL(href, location.origin).pathname.split('/').filter(Boolean); return p[p.length - 1] || ''; } catch (e) { return ''; }
  }
  function primary(li) { return li.querySelector('a.main-nav__item--primary') || li.querySelector(':scope > a'); }
  function arrow() { return '<span class="wmx__arr" aria-hidden="true">&rarr;</span>'; }

  /* modelnaam splitsen: "OVAL 2119" -> OVAL + 2119 */
  function nm(n) {
    var m = String(n).match(/^(.*?)\s+(\d{3,4}(?:\.\d+)?)$/);
    return m ? '<b>' + esc(m[1]) + '</b><span>' + esc(m[2]) + '</span>' : '<b>' + esc(n) + '</b>';
  }

  /* items uit het Shopify-menu (originele hrefs, ook na herschrijven door wave-menu.js) */
  function menuItems(li, topKey) {
    var out = [];
    li.querySelectorAll('.child-nav--dropdown a.child-nav__item').forEach(function (a) {
      if (a.classList.contains('main-nav__item-header')) return;
      var href = a.getAttribute('href') || '';
      if (!href) return;
      var k = key(href);
      if (out.some(function (o) { return o.u === href; })) return;
      var t = a.querySelector('.wm-name');
      var text = (t ? t.textContent : a.textContent).replace(/\s+/g, ' ').trim().replace(/\s*\(.*\)\s*$/, '');
      var inf = INFO[k] || {};
      if (/^alle\b/i.test(text)) return;
      out.push({ u: href, k: k, n: inf.n || text, s: inf.s || '', i: ART[k] || '', g: inf.g || '', hero: href.indexOf('#wvf') > -1 });
    });
    return out;
  }

  function card(it, fit) {
    return '<li><a class="wmx__card" href="' + esc(it.u) + '">' +
      '<span class="wmx__art' + (fit === 'cover' || it.ph ? ' wmx__art--cover' : '') + '">' + (it.i ? '<img src="' + esc(it.i) + '" alt="" loading="lazy" decoding="async">' : '') + '</span>' +
      '<span class="wmx__nm">' + nm(it.n) + '</span>' + (it.s ? '<span class="wmx__sub">' + esc(it.s) + '</span>' : '') + '</a></li>';
  }
  function row(it) {
    return '<li><a class="wmx__row" href="' + esc(it.u) + '">' +
      '<span class="wmx__th' + (it.ph ? ' wmx__th--cover' : '') + '">' + (it.i ? '<img src="' + esc(it.i) + '" alt="" loading="lazy" decoding="async">' : '') + '</span>' +
      '<span class="wmx__rt"><span class="wmx__nm">' + nm(it.n) + '</span>' + (it.s ? '<span class="wmx__sub">' + esc(it.s) + '</span>' : '') + '</span>' + arrow() + '</a></li>';
  }

  function cardsHtml(items, fit) {
    var n = items.length, c = n <= 5 ? n : Math.ceil(n / 2);
    return '<ul class="wmx__grid" style="--c:' + Math.max(c, 3) + '">' + items.map(function (it) { return card(it, fit); }).join('') + '</ul>';
  }
  function groupsHtml(items, order) {
    var gs = order || [];
    items.forEach(function (it) { if (gs.indexOf(it.g) < 0) gs.push(it.g); });
    var cols = 0;
    var inner = gs.map(function (g) {
      var list = items.filter(function (it) { return it.g === g; });
      if (!list.length) return '';
      var wide = list.length > 4;
      cols += wide ? 2 : 1;
      return '<div class="wmx__group' + (wide ? ' wmx__group--wide' : '') + '">' + (g ? '<p class="wmx__eyebrow">' + esc(g) + '</p>' : '') + '<ul>' + list.map(row).join('') + '</ul></div>';
    }).join('');
    return '<div class="wmx__groups" style="--g:' + Math.max(cols, 2) + '">' + inner + '</div>';
  }
  function frameHtml(items, p) {
    var hero = items.filter(function (it) { return it.hero; })[0];
    var picks = items.filter(function (it) { return !it.hero && (p.pick || []).indexOf(it.k) > -1; });
    var minor = items.filter(function (it) { return !it.hero && (p.pick || []).indexOf(it.k) < 0; });
    var h = '<div class="wmx__frame">';
    if (hero) {
      h += '<a class="wmx__hero" href="' + esc(hero.u) + '"><span class="wmx__hero-ey">' + esc(p.he || 'Configurator') + '</span>' +
        '<span class="wmx__hero-t">' + esc(hero.n) + '</span><span class="wmx__hero-d">' + esc(p.hd || '') + '</span>' +
        '<span class="wmx__hero-pic" aria-hidden="true">' + (p.hp || '') + '</span>' +
        '<span class="wmx__hero-cta">' + esc(p.hc || 'Begin met samenstellen') + ' ' + arrow() + '</span></a>';
    }
    h += '<ul class="wmx__grid wmx__grid--pick" style="--c:' + picks.length + '">' + picks.map(function (it) { return card(it); }).join('') + '</ul>';
    if (minor.length) {
      h += '<div class="wmx__minor"><span class="wmx__eyebrow">' + esc(p.mh || 'Ook nodig') + '</span>' + minor.map(function (it) {
        return '<a class="wmx__chip" href="' + esc(it.u) + '">' + (it.i ? '<img src="' + esc(it.i) + '" alt="" loading="lazy">' : '') + esc((p.cn && p.cn[it.k]) || it.n) + '</a>';
      }).join('') + '</div>';
    }
    return h + '</div>';
  }
  function colorsHtml(p) {
    var h = '<div class="wmx__colors">';
    (p.blocks || []).forEach(function (b) {
      h += '<a class="wmx__cb' + (b.wide ? ' wmx__cb--fan' : '') + '" href="' + esc(b.u || p.u) + '">';
      h += '<span class="wmx__eyebrow">' + esc(b.t) + '</span>';
      if (b.sw) {
        h += '<span class="wmx__sws' + (b.small ? ' wmx__sws--sm' : '') + '">' + b.sw.map(function (s) {
          return '<span class="wmx__sw"><i style="--c:' + esc(s[1]) + '" title="' + esc(s[0]) + '"></i>' + (b.small ? '' : '<em>' + esc(s[0]) + '</em>') + '</span>';
        }).join('') + '</span>';
      }
      if (b.wide) h += '<span class="wmx__fan" aria-hidden="true"></span>';
      h += '<span class="wmx__cbd">' + esc(b.d) + '</span><span class="wmx__more">' + esc(b.c || 'Bekijken') + ' ' + arrow() + '</span></a>';
    });
    return h + '</div>';
  }

  function build(li) {
    if (li.querySelector(':scope > .wmx')) return;
    var a = primary(li);
    if (!a) return;
    var k = li.getAttribute('data-wm-key') || key(a.getAttribute('href'));
    var p = M.p[k];
    if (!p) return;
    var href = a.getAttribute('href');
    var items = p.items ? p.items.slice() : menuItems(li, k);
    var body = '';
    if (p.mode === 'frame') body = frameHtml(items, p);
    else if (p.mode === 'groups') body = groupsHtml(items, p.order);
    else if (p.mode === 'colors') body = colorsHtml(Object.assign({ u: href }, p));
    else body = cardsHtml(items, p.fit);

    var h = '<div class="wmx__in' + (p.i ? '' : ' wmx__in--full') + '">';
    if (p.i) {
      h += '<a class="wmx__feat' + (p.fc ? ' wmx__feat--contain' : '') + '" href="' + esc(p.fu || href) + '"><img src="' + esc(p.i) + '" alt="" loading="lazy" decoding="async">' +
        '<span class="wmx__feat-tx"><span class="wmx__feat-ey">' + esc(p.e || 'Collectie') + '</span><span class="wmx__feat-t">' + esc(p.t) + '</span>' +
        '<span class="wmx__feat-d">' + esc(p.d) + '</span><span class="wmx__feat-cta">' + esc(p.c || 'Bekijk alles') + ' ' + arrow() + '</span></span></a>';
    }
    h += '<div class="wmx__main"><div class="wmx__head"><p class="wmx__title">' + esc(p.h || p.t) + '</p>' +
      (p.all !== 0 ? '<a class="wmx__all" href="' + esc(p.au || href) + '">' + esc(p.al || ('Alle ' + p.t.toLowerCase())) + ' ' + arrow() + '</a>' : '') + '</div>' + body + '</div></div>';
    h += '<div class="wmx__bar"><ul class="wmx__usp">' + (M.usp || []).map(function (u) { return '<li>' + esc(u) + '</li>'; }).join('') + '</ul>' +
      (document.querySelector('.wave-chat-btn') ? '<button type="button" class="wmx__chat" data-wmx-chat>' + esc(M.chat || 'Advies nodig? Chat met ons') + '</button>' : '') + '</div>';

    var d = document.createElement('div');
    d.className = 'wmx';
    d.setAttribute('role', 'region');
    d.setAttribute('aria-label', p.t);
    d.innerHTML = h;
    li.appendChild(d);
    li.classList.add('has-wmx');
    var btn = d.querySelector('[data-wmx-chat]');
    if (btn) btn.addEventListener('click', function () { close(); var c = document.querySelector('.wave-chat-btn'); if (c) c.click(); });
  }
  function buildAll() {
    if (built) return;
    built = true;
    tops.forEach(build);
  }

  function setOpen(li) {
    if (openLi === li) return;
    if (openLi) { openLi.classList.remove('wmx-open'); var t = openLi.querySelector('.main-nav__toggle-btn'); if (t) t.setAttribute('aria-expanded', 'false'); }
    openLi = li;
    if (li) {
      buildAll();
      if (!li.querySelector(':scope > .wmx')) { openLi = null; return; }
      fit(li);
      li.classList.add('wmx-open');
      var b = li.querySelector('.main-nav__toggle-btn'); if (b) b.setAttribute('aria-expanded', 'true');
    }
    document.documentElement.classList.toggle('wmx-active', !!openLi);
  }
  function close() { clearTimeout(tOpen); setOpen(null); }
  function fit(li) {
    var p = li.querySelector(':scope > .wmx');
    if (!p) return;
    var top = (li.closest('main-menu') || nav).getBoundingClientRect().bottom;
    p.style.setProperty('--wmx-maxh', Math.max(320, Math.round(window.innerHeight - top - 12)) + 'px');
  }

  tops.forEach(function (li) {
    if (!M.p[li.getAttribute('data-wm-key') || '']) return;
    li.classList.add('has-wmx');
    li.addEventListener('mouseenter', function () {
      if (!mq.matches) return;
      clearTimeout(tClose); clearTimeout(tOpen);
      if (openLi && openLi !== li) setOpen(li);
      else tOpen = setTimeout(function () { setOpen(li); }, 70);
    });
    li.addEventListener('mouseleave', function () {
      if (!mq.matches) return;
      clearTimeout(tOpen);
      tClose = setTimeout(function () { if (openLi === li) setOpen(null); }, 160);
    });
    li.addEventListener('focusin', function () { if (mq.matches) { clearTimeout(tClose); setOpen(li); } });
    var tb = li.querySelector('.main-nav__toggle-btn');
    if (tb) tb.addEventListener('click', function (e) {
      if (!mq.matches) return;
      e.preventDefault(); e.stopImmediatePropagation();
      setOpen(openLi === li ? null : li);
    }, true);
  });
  nav.addEventListener('mouseenter', function () { if (mq.matches) buildAll(); });
  document.addEventListener('focusout', function (e) {
    if (!openLi) return;
    setTimeout(function () { if (openLi && !openLi.contains(document.activeElement)) setOpen(null); }, 0);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !openLi) return;
    var a = primary(openLi);
    close();
    if (a) a.focus();
  });
  window.addEventListener('scroll', function () { if (openLi) fit(openLi); }, { passive: true });
  if (mq.addEventListener) mq.addEventListener('change', function () { close(); });
  /* panelen alvast opbouwen als de pagina rustig is, zodat beelden klaarstaan */
  (window.requestIdleCallback || function (f) { setTimeout(f, 2500); })(function () { if (mq.matches) buildAll(); });
})();
